<template>
  <v-layout wrap>
    <v-flex xs6 sm4 v-for="bot in botlist" :key="bot.pageid">
      <v-checkbox
        v-model="selected"
        :label="bot.pagename"
        :value="`${bot.pageid}`"
        color="primary"
        hide-details
      ></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: ['value'],
  computed: {
    ...mapGetters({
      // selectedBot: 'selectedBot',
      isFacebook: 'isFacebook',
      botlist: 'botlist'
    })
  },
  data() {
    return {
      selected: []
    }
  },
  mounted() {
    if (this.value != null) {
      this.selected = this.value.split(',')
    }
  },
  watch: {
    selected(newVal) {
      var pageidlist = newVal.filter(el => {
        return el != ''
      })
      this.$emit('input', pageidlist.join(','))
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/PageList.vue